/**
 * マニフェスト管理
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";
import * as types from "../../../mutation-types/driver-types";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements`;

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0,
    },
    condition: {
      /* 1次・2次マニフェスト区分 */
      type_of_manifest: "first_manifest",
      /* マニフェスト番号検索(range:範囲指定, specify: 番号指定) */
      specify_type: "range",
      /* マニフェスト番号 範囲開始 */
      start_no: null,
      /* マニフェスト番号 範囲終了 */
      end_no: null,
      /* マニフェスト番号 */
      manifest_numbers: null,

      /* マニフェスト区分 */
      manifest_type: null,
      /* 引渡日 開始日 */
      start_date: null,
      /* 引渡日 終了日 */
      end_date: null,
      /* JWNET取扱品目 */
      item_id: null,
      /* DXE起票担当者 */
      vote_staff: null,

      /* 回収先 排出事業者ID */
      supplier_id: null,
      /* 回収先 排出事業者種別 */
      supplier_type: "Emission",
      /* 回収先 排出事業場ID */
      supplier_location_id: null,
      /* 回収先 排出事業場コード */
      supplier_location_code: null,

      /* 回収先 収運・処分事業者ID */
      supplier_trader_id: null,
      /* 回収先 収運・処分事業者種別 */
      supplier_trader_type: "Trader",
      /* 回収先 収運・処分事業場ID */
      supplier_trader_location_id: null,
      /* 回収先 収運・処分事業場コード */
      supplier_trader_location_code: null,

      /* 収運業者 */
      transporter_id: null,

      /* 処分事業者ID */
      trader_id: null,
      /* 処分事業場ID */
      trader_location_id: null,
      /* 処分事業場コード */
      trader_location_code: null,

      /* 受注番号ありのみ検索 */
      ordered: false,
      /* 受注番号 */
      order_no: null,
      /* 引取搬入番号 */
      request_no: null,
      /* DXEマニ番号(1次) */
      manifest_id: null,
      /* DXEマニ番号(2次) */
      relation_manifest_id: null,
      /* マニ取消済のみ検索 */
      canceled: false,

      /* 運搬報告状況 */
      transport_report_state: null,
      /* 運搬終了日 開始日 */
      transport_completed_date_from: null,
      /* 運搬終了日 終了日 */
      transport_completed_date_to: null,
      /* 運搬報告区間指定 */
      section_no: null,

      /* 処分報告状況 */
      disposal_report_state: null,
      /* 処分終了日 開始日 */
      disposal_completed_date_from: null,
      /* 処分終了日 終了日 */
      disposal_completed_date_to: null,
      /* 処分方法 */
      disposal_method_ids: null,
      /* 登録業者/JWNET取込業者 */
      self_manifest: null,
      /* 廃棄物の名称 */
      waste_name: null,

      /* 最終報告状況 */
      final_report_state: null,
      /* 最終終了日 開始日 */
      final_disposal_end_from: null,
      /* 最終終了日 終了日 */
      final_disposal_end_to: null,
      /* 排出者承認 */
      approval_state: null,
      /* 表示順 */
      sort_type: "updated_date_desc",

      /* ステータス(EDIのみ) */
      manifest_condition_status: null,
      /* 期限切れ(ED) */
      expired_status: null,
      /* 期限切れ間近(EDI) */
      neared_status: null,
      /* マニフェスト検索キーワード */
      manifest_search_keyword: null,
      /* 排出事業場コード */
      location_code: null,
      /* 排出事業場名称 */
      location_name: null,

      /* 区間1運搬事業者 */
      section_1_transporter: null,
      /* ルート */
      transport_route_id: null,

      /* カスタムラベル1 */
      custom_labels_1: null,
      /* ラベル①の利用有無 */
      custom_labels_1_unregistered: false,

      /* カスタムラベル2 */
      custom_labels_2: null,
      /* ラベル②の利用有無 */
      custom_labels_2_unregistered: false,

      /* カスタムラベル3 */
      custom_labels_3: null,
      /* ラベル③の利用有無 */
      custom_labels_3_unregistered: false,
      /* カスタムラベル4 */
      custom_labels_4: null,
      /* ラベル④の利用有無 */
      custom_labels_4_unregistered: false,
      /* カスタムラベル5 */
      custom_labels_5: null,
      /* ラベル⑤の利用有無 */
      custom_labels_5_unregistered: false,
      /* カスタムラベル6 */
      custom_labels_6: null,
      /* ラベル⑥の利用有無 */
      custom_labels_6_unregistered: false,

      /* 選択された日付 */
      target_date: null,

      recovery_order_id: null,
      recovery_order_type: null,

      limit: 50,


    },
    selectableTab: 0,
    selectedItemsFirst: [],
    individualItemsFirst: [],
    selectedItemsSecond: [],
    individualItemsSecond: [],
  };
};

const manifest_management = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: (state) => {
      return state.pagination.total_count > 0;
    },
    selectedMembers: (state) => {
      if (state.condition.type_of_manifest === "first_manifest") {
        return state.selectedItemsFirst;
      } else {
        return state.selectedItemsSecond;
      }
    },
  },
  actions: {
    /**
     * マニフェスト管理取得
     * @param dispatch
     * @param commit
     * @param state
     * @param conditions { Object }
     * @param selectable_tab { Number } 検索パターン
     * @param page { Number }
     * @param limit { Number }
     * @param layout { String }
     * @param format { String }
     * @return {Promise<unknown>}
     */
    index( { dispatch, commit, state }, { conditions, selectable_tab, page, limit, layout, format } ) {
      let api_path;
      if (format === "csv") {
        api_path = `${API_PATH}.csv`;
      } else {
        api_path = `${API_PATH}`;
      }
      dispatch("saveCondition", { conditions: conditions, selectable_tab: selectable_tab, limit: limit });
      const params = {
        ...state.condition,
        limit: state.condition.limit,
        page: page,
        layout: layout,
        format: format,
      }

      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then((data) => {
          if (format !== "csv") {
            let content = data.content;
            commit(types.DRIVER_MANIFEST_MANAGEMENT_PAGINATION, { content });
            resolve(content);
          } else {
            resolve(data);
          }
        });
      });
    },
    show({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`;
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then((data) => {
          resolve(data.content);
        });
      });
    },
    /**
     * マニフェスト管理 初期データ取得
     * @return {Promise<unknown>}
     */
    new({ commit }) {
      const api_path = `${API_PATH}/new`;
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then((data) => {
          const content = data.content;
          resolve(content);
        });
      });
    },
    edit({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`;
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then((data) => {
          resolve(data.content);
        });
      });
    },
    create({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        Vue.$http.post(API_PATH, params, {headers: { "content-type": "multipart/form-data" },}).then((data) => {
          const content = data.content;
          commit(
            "freelySnackbar/showInfo",
            {
              title: "登録しました",
              subTitle: "DXEマニ番号",
              messages: [content.manifest_id],
              enableCopy: true,
              timeout: 6000,
            },
            { root: true }
          );
          resolve(content);
        // }).catch(error => {
        //   reject(error)
        });
      });
    },
    /**
     * マニフェストの更新
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update({ commit }, { id, params }) {
      return new Promise((resolve, reject) => {
        const api_path = `${API_PATH}/${id}`;
        Vue.$http.put(api_path, params).then((data) => {
          let content = data.content;
          commit(
            "snackbar/showInfo",
            { message: "登録しました" },
            { root: true }
          );
          resolve(content);
        // }).catch(error => {
        //   reject(error)
        });
      });
    },
    /**
     * マニフェストのキャンセル
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    destroy({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`;
      return new Promise((resolve) => {
        Vue.$http.delete(api_path).then((data) => {
          commit(
            "snackbar/showInfo",
            { message: "取消しました" },
            { root: true }
          );
          resolve(data.content);
        });
      });
    },
    /**
     * 検索条件の保持
     * @param commit
     * @param state
     * @param conditions { Object }
     * @param selectable_tab { Number }
     * @param limit {Number}
     */
    saveCondition({ commit, state }, { conditions, selectable_tab, limit }) {
      /* 1次・2次マニフェスト区分 */
      const _type_of_manifest = conditions.type_of_manifest !== undefined ? conditions.type_of_manifest : state.condition.type_of_manifest
      /* マニフェスト番号検索(range:範囲指定, specify: 番号指定) */
      const _specify_type = conditions.specify_type !== undefined ? conditions.specify_type : state.condition.specify_type
      /* マニフェスト番号 範囲開始 */
      const _start_no = conditions.start_no !== undefined ? conditions.start_no : state.condition.start_no
      /* マニフェスト番号 範囲終了 */
      const _end_no = conditions.end_no !== undefined ? conditions.end_no : state.condition.end_no
      /* マニフェスト番号 */
      const _manifest_numbers = conditions.manifest_numbers !== undefined ? conditions.manifest_numbers : state.condition.manifest_numbers

      /* マニフェスト区分 */
      const _manifest_type = conditions.manifest_type !== undefined ? conditions.manifest_type : state.condition.manifest_type
      /* 引渡日 開始日 */
      const _start_date = conditions.start_date !== undefined ? conditions.start_date : state.condition.start_date
      /* 引渡日 終了日 */
      const _end_date = conditions.end_date !== undefined ? conditions.end_date : state.condition.end_date
      /* JWNET取扱品目 */
      const _item_id = conditions.item_id !== undefined ? conditions.item_id : state.condition.item_id
      /* DXE起票担当者 */
      const _vote_staff = conditions.vote_staff !== undefined ? conditions.vote_staff : state.condition.vote_staff

      /* 回収先 排出事業者ID */
      const _supplier_id = conditions.supplier_id !== undefined ? conditions.supplier_id : state.condition.supplier_id
      /* 回収先 排出事業者種別 */
      const _supplier_type = conditions.supplier_type !== undefined ? conditions.supplier_type : state.condition.supplier_type
      /* 回収先 排出事業場ID */
      const _supplier_location_id = conditions.supplier_location_id !== undefined ? conditions.supplier_location_id : state.condition.supplier_location_id
      /* 回収先 排出事業場コード */
      const _supplier_location_code = conditions.supplier_location_code !== undefined ? conditions.supplier_location_code : state.condition.supplier_location_code
      /* 回収先 収運・処分事業者ID */
      const _supplier_trader_id = conditions.supplier_trader_id !== undefined ? conditions.supplier_trader_id : state.condition.supplier_trader_id
      /* 回収先 収運・処分事業者種別 */
      const _supplier_trader_type = conditions.supplier_trader_type !== undefined ? conditions.supplier_trader_type : state.condition.supplier_trader_type
      /* 回収先 収運・処分事業場ID */
      const _supplier_trader_location_id = conditions.supplier_trader_location_id !== undefined ? conditions.supplier_trader_location_id : state.condition.supplier_trader_location_id
      /* 回収先 収運・処分事業場コード */
      const _supplier_trader_location_code = conditions.supplier_trader_location_code !== undefined ? conditions.supplier_trader_location_code : state.condition.supplier_trader_location_code
      /* 収運業者 */
      const _transporter_id = conditions.transporter_id !== undefined ? conditions.transporter_id : state.condition.transporter_id
      /* 処分事業者ID */
      const _trader_id = conditions.trader_id !== undefined ? conditions.trader_id : state.condition.trader_id
      /* 処分事業場ID */
      const _trader_location_id = conditions.trader_location_id !== undefined ? conditions.trader_location_id : state.condition.trader_location_id
      /* 処分事業場コード */
      const _trader_location_code = conditions.trader_location_code !== undefined ? conditions.trader_location_code : state.condition.trader_location_code

      /* 受注番号ありのみ検索 */
      const _ordered = conditions.ordered !== undefined ? conditions.ordered : state.condition.ordered
      /* 受注番号 */
      const _order_no = conditions.order_no !== undefined ? conditions.order_no : state.condition.order_no
      /* 引取搬入番号 */
      const _request_no = conditions.request_no !== undefined ? conditions.request_no : state.condition.request_no
      /* DXEマニ番号(1次) */
      const _manifest_id = conditions.manifest_id !== undefined ? conditions.manifest_id : state.condition.manifest_id
      /* DXEマニ番号(2次) */
      const _relation_manifest_id = conditions.relation_manifest_id !== undefined ? conditions.relation_manifest_id : state.condition.relation_manifest_id
      /* マニ取消済のみ検索 */
      const _canceled = conditions.canceled !== undefined ? conditions.canceled : state.condition.canceled
      /* 運搬報告状況 */
      const _transport_report_state = conditions.transport_report_state !== undefined ? conditions.transport_report_state : state.condition.transport_report_state
      /* 運搬終了日 開始日 */
      const _transport_completed_date_from = conditions.transport_completed_date_from !== undefined ? conditions.transport_completed_date_from : state.condition.transport_completed_date_from
      /* 運搬終了日 終了日 */
      const _transport_completed_date_to = conditions.transport_completed_date_to !== undefined ? conditions.transport_completed_date_to : state.condition.transport_completed_date_to
      /* 運搬報告区間指定 */
      const _section_no = conditions.section_no !== undefined ? conditions.section_no : state.condition.section_no

      /* 処分報告状況 */
      const _disposal_report_state = conditions.disposal_report_state !== undefined ? conditions.disposal_report_state : state.condition.disposal_report_state
      /* 処分終了日 開始日 */
      const _disposal_completed_date_from = conditions.disposal_completed_date_from !== undefined ? conditions.disposal_completed_date_from : state.condition.disposal_completed_date_from
      /* 処分終了日 終了日 */
      const _disposal_completed_date_to = conditions.disposal_completed_date_to !== undefined ? conditions.disposal_completed_date_to : state.condition.disposal_completed_date_to
      /* 処分方法 */
      const _disposal_method_ids = conditions.disposal_method_ids !== undefined ? conditions.disposal_method_ids : state.condition.disposal_method_ids
      /* 登録業者/JWNET取込業者 */
      const _self_manifest = conditions.self_manifest !== undefined ? conditions.self_manifest : state.condition.self_manifest
      /* 廃棄物の名称 */
      const _waste_name = conditions.waste_name !== undefined ? conditions.waste_name : state.condition.waste_name

      /* 最終報告状況 */
      const _final_report_state = conditions.final_report_state !== undefined ? conditions.final_report_state : state.condition.final_report_state
      /* 最終終了日 開始日 */
      const _final_disposal_end_from = conditions.final_disposal_end_from !== undefined ? conditions.final_disposal_end_from : state.condition.final_disposal_end_from
      /* 最終終了日 終了日 */
      const _final_disposal_end_to = conditions.final_disposal_end_to !== undefined ? conditions.final_disposal_end_to : state.condition.final_disposal_end_to
      /* 排出者承認 */
      const _approval_state = conditions.approval_state !== undefined ? conditions.approval_state : state.condition.approval_state
      /* 表示順 */
      const _sort_type = conditions.sort_type !== undefined ? conditions.sort_type : state.condition.sort_type

      /* ステータス(EDIのみ) */
      const _manifest_condition_status = conditions.manifest_condition_status !== undefined ? conditions.manifest_condition_status : state.condition.manifest_condition_status
      /* 期限切れのみ検索(EDIのみ) */
      const _expired_status = conditions.expired_status !== undefined ? conditions.expired_status : state.condition.expired_status
      /* 期限切れ間近のみ検索(EDIのみ) */
      const _neared_status = conditions.neared_status !== undefined ? conditions.neared_status : state.condition.neared_status
      /* マニフェスト検索キーワード */
      const _manifest_search_keyword = conditions.manifest_search_keyword !== undefined ? conditions.manifest_search_keyword : state.condition.manifest_search_keyword
      /* 排出事業場コード */
      const _location_code = conditions.location_code !== undefined ? conditions.location_code : state.condition.location_code
      /* 排出事業場名称 */
      const _location_name = conditions.location_name !== undefined ? conditions.location_name : state.condition.location_name
      /* 区間1運搬事業者 */
      const _section_1_transporter = conditions.section_1_transporter !== undefined ? conditions.section_1_transporter : state.condition.section_1_transporter
      /* ルート */
      const _transport_route_id = conditions.transport_route_id !== undefined ? conditions.transport_route_id : state.condition.transport_route_id

      /* カスタムラベル1 */
      const _custom_labels_1 = conditions.custom_labels_1 !== undefined ? conditions.custom_labels_1 : state.condition.custom_labels_1
      /* ラベル①の利用有無 */
      const _custom_labels_1_unregistered = conditions.custom_labels_1_unregistered !== undefined ? conditions.custom_labels_1_unregistered : state.condition.custom_labels_1_unregistered
      /* カスタムラベル2 */
      const _custom_labels_2 = conditions.custom_labels_2 !== undefined ? conditions.custom_labels_2 : state.condition.custom_labels_2
      /* ラベル②の利用有無 */
      const _custom_labels_2_unregistered = conditions.custom_labels_2_unregistered !== undefined ? conditions.custom_labels_2_unregistered : state.condition.custom_labels_2_unregistered
      /* カスタムラベル3 */
      const _custom_labels_3 = conditions.custom_labels_3 !== undefined ? conditions.custom_labels_3 : state.condition.custom_labels_3
      /* ラベル③の利用有無 */
      const _custom_labels_3_unregistered = conditions.custom_labels_3_unregistered !== undefined ? conditions.custom_labels_3_unregistered : state.condition.custom_labels_3_unregistered
      /* カスタムラベル4 */
      const _custom_labels_4 = conditions.custom_labels_4 !== undefined ? conditions.custom_labels_4 : state.condition.custom_labels_4
      /* ラベル④の利用有無 */
      const _custom_labels_4_unregistered = conditions.custom_labels_4_unregistered !== undefined ? conditions.custom_labels_4_unregistered : state.condition.custom_labels_4_unregistered
      /* カスタムラベル5 */
      const _custom_labels_5 = conditions.custom_labels_5 !== undefined ? conditions.custom_labels_5 : state.condition.custom_labels_5
      /* ラベル⑤の利用有無 */
      const _custom_labels_5_unregistered = conditions.custom_labels_5_unregistered !== undefined ? conditions.custom_labels_5_unregistered : state.condition.custom_labels_5_unregistered
      /* カスタムラベル6 */
      const _custom_labels_6 = conditions.custom_labels_6 !== undefined ? conditions.custom_labels_6 : state.condition.custom_labels_6
      /* ラベル⑥の利用有無 */
      const _custom_labels_6_unregistered = conditions.custom_labels_6_unregistered !== undefined ? conditions.custom_labels_6_unregistered : state.condition.custom_labels_6_unregistered
      /* 選択された日付 */
      const _target_date = conditions.target_date !== undefined ? conditions.target_date : state.condition.target_date

      const _recovery_order_id = conditions.recovery_order_id !== undefined ? conditions.recovery_order_id : state.condition.recovery_order_id
      const _recovery_order_type = conditions.recovery_order_type !== undefined ? conditions.recovery_order_type : state.condition.recovery_order_type

      const _limit = limit !== undefined ? limit : state.condition.limit;

      const params = {
        type_of_manifest: _type_of_manifest,

        specify_type: _specify_type,
        start_no: _start_no,
        end_no: _end_no,
        manifest_numbers: _manifest_numbers,

        manifest_type: _manifest_type,
        start_date: _start_date,
        end_date: _end_date,
        item_id: _item_id,
        vote_staff: _vote_staff,

        supplier_id: _supplier_id,
        supplier_type: _supplier_type,
        supplier_location_id: _supplier_location_id,
        supplier_location_code: _supplier_location_code,
        supplier_trader_id: _supplier_trader_id,
        supplier_trader_type: _supplier_trader_type,
        supplier_trader_location_id: _supplier_trader_location_id,
        supplier_trader_location_code: _supplier_trader_location_code,
        transporter_id: _transporter_id,
        trader_id: _trader_id,
        trader_location_id: _trader_location_id,
        trader_location_code: _trader_location_code,

        ordered: _ordered,
        order_no: _order_no,
        request_no: _request_no,
        manifest_id: _manifest_id,
        relation_manifest_id: _relation_manifest_id,
        canceled: _canceled,
        transport_report_state: _transport_report_state,
        transport_completed_date_from: _transport_completed_date_from,
        transport_completed_date_to: _transport_completed_date_to,
        section_no: _section_no,

        disposal_report_state: _disposal_report_state,
        disposal_completed_date_from: _disposal_completed_date_from,
        disposal_completed_date_to: _disposal_completed_date_to,
        disposal_method_ids: _disposal_method_ids,
        self_manifest: _self_manifest,
        waste_name: _waste_name,

        final_report_state: _final_report_state,
        final_disposal_end_from: _final_disposal_end_from,
        final_disposal_end_to: _final_disposal_end_to,
        approval_state: _approval_state,
        sort_type: _sort_type,

        manifest_condition_status: _manifest_condition_status,
        expired_status: _expired_status,
        neared_status: _neared_status,
        manifest_search_keyword: _manifest_search_keyword,
        location_code: _location_code,
        location_name: _location_name,

        section_1_transporter: _section_1_transporter,
        transport_route_id: _transport_route_id,

        custom_labels_1: _custom_labels_1,
        custom_labels_1_unregistered: _custom_labels_1_unregistered,
        custom_labels_2: _custom_labels_2,
        custom_labels_2_unregistered: _custom_labels_2_unregistered,
        custom_labels_3: _custom_labels_3,
        custom_labels_3_unregistered: _custom_labels_3_unregistered,
        custom_labels_4: _custom_labels_4,
        custom_labels_4_unregistered: _custom_labels_4_unregistered,
        custom_labels_5: _custom_labels_5,
        custom_labels_5_unregistered: _custom_labels_5_unregistered,
        custom_labels_6: _custom_labels_6,
        custom_labels_6_unregistered: _custom_labels_6_unregistered,

        target_date: _target_date,
        recovery_order_id: _recovery_order_id,
        recovery_order_type: _recovery_order_type,
        limit: _limit,
      };
      commit(types.DRIVER_MANIFEST_MANAGEMENT_CONDITION, { params: params });
      commit(types.DRIVER_MANIFEST_MANAGEMENT_TAB, { selectable_tab: selectable_tab });
    },
    resetState({ commit }) {
      commit(types.DRIVER_MANIFEST_MANAGEMENT_RESET_CONDITION);
      commit(types.DRIVER_MANIFEST_MANAGEMENT_RESET_PAGINATION);
      commit(types.DRIVER_MANIFEST_MANAGEMENT_RESET_TAB);
    },
    resetPagination({ commit }) {
      commit(types.DRIVER_MANIFEST_MANAGEMENT_RESET_PAGINATION);
    },
  },
  mutations: {
    [types.DRIVER_MANIFEST_MANAGEMENT_PAGINATION](state, { content }) {
      state.pagination = content.pagination;
    },
    [types.DRIVER_MANIFEST_MANAGEMENT_RESET_PAGINATION](state) {
      Object.assign(state.pagination, getDefaultState().pagination);
    },
    [types.DRIVER_MANIFEST_MANAGEMENT_RESET_CONDITION](state) {
      state.selectableTab = 0;
      Object.assign(state.condition, getDefaultState().condition);
    },
    [types.DRIVER_MANIFEST_MANAGEMENT_CONDITION](state, { params }) {
      Object.assign(state.condition, params);
    },
    [types.DRIVER_MANIFEST_MANAGEMENT_TAB](state, { selectable_tab }) {
      state.selectableTab = selectable_tab;
    },
    [types.DRIVER_MANIFEST_MANAGEMENT_RESET_TAB](state) {
      state.selectableTab = 0;
    },

  },
};

export default manifest_management;
